import { TAGULAR_COOKIE, TAGULAR_EVENT_TYPES } from "@/types/tagular";
import { tagular } from "@redventures/cohesion-utils-react";

/**
 * Utility: fireCookieIdentified
 *
 * @see {@link https://app.make.rvapps.io/schemas/sch_1KdMzsc0YgTOCOG48JxOPsMOkej | CookieIdentified Schema}
 */
const fireCookieIdentified = (eventOptions: TAGULAR_COOKIE) => {
  const { key = "", value = "" } = eventOptions;

  if (!key && !value) return;

  tagular("beam", {
    "@type": TAGULAR_EVENT_TYPES.COOKIE_IDENTIFIED,
    key: key,
    value: value,
  });
};

export default fireCookieIdentified;
